export const DELETE_TAG_REQUEST = 'DELETE_TAG_REQUEST';

export const deleteTagRequest = ( id: string ) => ({
    type: DELETE_TAG_REQUEST,
    payload: { id }
});
